export default {
  name: 'CardList',
  displayName: {
    en: 'Card List',
    ja: 'カードリスト',
  },
  icon: './icon.png',
  defaultWidth: 375,
  defaultHeight: 528,
  resizeX: true,
  props: [
    {
      name: 'items',
      displayName: {
        en: 'What is this a list of?',
        ja: 'データベースの選択',
      },
      type: 'list',
    },
    {
      name: 'sortList',
      displayName: {
        en: 'Sorting',
        ja: '並び替え',
      },
      type: 'sort',
    },
    {
      name: 'maximumItems',
      displayName: {
        en: 'Maximum number of items',
        ja: '上限',
      },
      type: 'maximumItems',
    },
    {
      name: 'columnCount',
      displayName: {
        en: 'Columns',
        ja: '列',
      },
      type: 'number',
      default: 2,
      control: {
        type: 'menu',
        options: [
          {
            label: '1',
            value: 1,
          },
          {
            label: '2',
            value: 2,
          },
          {
            label: '3',
            value: 3,
          },
          {
            label: '4',
            value: 4,
          },
        ],
      },
    },
    {
      name: 'onPress',
      displayName: {
        en: 'List',
        ja: 'リスト',
      },
      type: 'action',
      role: 'listItem',
      reference: 'items',
    },
  ],
  childComponents: [
    {
      displayName: {
        en: 'Image',
        ja: '画像',
      },
      name: 'cardCover',
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'image',
          displayName: {
            en: 'Image Source',
            ja: '画像ソース',
          },
          type: 'image',
          styles: {
            borderRadius: true,
          },
        },
      ],
    },
    {
      name: 'title',
      displayName: {
        en: 'Title',
        ja: 'タイトル',
      },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Title',
          styles: {
            color: '@text',
          },
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: 'true',
        },
        {
          name: 'titleLineNum',
          displayName: {
            en: 'Number of Lines',
            ja: '行数',
          },
          type: 'number',
          default: 1,
          control: {
            type: 'menu',
            options: [
              {
                label: 'canvas.menuRight.elementTab.list.singleLine',
                value: 1,
              },
              {
                label: 'canvas.menuRight.elementTab.list.multiLine',
                value: 2,
              },
            ],
          },
        },
      ],
    },
    {
      name: 'subTitle',
      displayName: {
        en: 'Sub Title',
        ja: 'サブタイトル',
      },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Sub Title',
          styles: {
            color: '@text',
          },
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: 'true',
        },
        {
          name: 'subtitleLineNum',
          displayName: {
            en: 'Number of Lines',
            ja: '行数',
          },
          type: 'number',
          default: 1,
          control: {
            type: 'menu',
            options: [
              {
                label: 'canvas.menuRight.elementTab.list.singleLine',
                value: 1,
              },
              {
                label: 'canvas.menuRight.elementTab.list.multiLine',
                value: 2,
              },
            ],
          },
        },
      ],
    },
    {
      name: 'subTitle2',
      displayName: {
        en: 'Sub Title 2',
        ja: 'サブタイトル2',
      },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Sub Title 2',
          styles: {
            color: '@text',
          },
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: 'true',
        },
        {
          name: 'subtitle2LineNum',
          displayName: {
            en: 'Number of Lines',
            ja: '行数',
          },
          type: 'number',
          default: 1,
          control: {
            type: 'menu',
            options: [
              {
                label: 'canvas.menuRight.elementTab.list.singleLine',
                value: 1,
              },
              {
                label: 'canvas.menuRight.elementTab.list.multiLine',
                value: 2,
              },
            ],
          },
        },
      ],
    },
    {
      name: 'button1',
      displayName: {
        en: 'Button 1',
        ja: 'ボタン1',
      },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Button 1',
          styles: {
            color: '@text',
            backgroundColor: '@text',
          },
        },
        {
          name: 'onPress',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
          type: 'action',
        },
      ],
    },
    {
      name: 'icon1',
      displayName: {
        en: 'Icon 1',
        ja: 'アイコン1',
      },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'iconType',
          displayName: {
            en: 'Type',
            ja: 'タイプ',
          },
          type: 'text',
          default: 'icon',
          control: {
            type: 'menu',
            options: [
              {
                label: 'Icon',
                value: 'icon',
              },
              {
                label: 'Toggle',
                value: 'toggle',
              },
            ],
          },
        },
        {
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          name: 'icon',
          type: 'icon',
          default: 'favorite',
        },
        {
          name: 'onPress',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
          type: 'action',
          enabled: {
            iconType: ['icon', 'toggle'],
          },
        },
        {
          name: 'color',
          displayName: {
            en: 'Icon Color',
            ja: 'アイコン色',
          },
          type: 'color',
          default: '@primary',
        },
        {
          name: 'input',
          displayName: {
            en: 'What does this toggle?',
            ja: 'データを選択してください',
          },
          type: 'boolean',
          role: 'autosaveInput',
          enabled: {
            iconType: 'toggle',
          },
        },
        {
          name: 'activeIcon',
          displayName: {
            en: 'Active Icon',
            ja: 'アクティブ時のアイコン',
          },
          type: 'icon',
          default: 'check-box',
          enabled: {
            iconType: 'toggle',
          },
        },
        {
          name: 'activeColor',
          displayName: {
            en: 'Active Color',
            ja: 'アクティブ時の色',
          },
          type: 'color',
          default: '@primary',
          enabled: {
            iconType: 'toggle',
          },
        },
        {
          name: 'inactiveIcon',
          displayName: {
            en: 'Inactive Icon',
            ja: '非アクティブ時のアイコン',
          },
          type: 'icon',
          default: 'check-box-outline-blank',
          enabled: {
            iconType: 'toggle',
          },
        },
        {
          name: 'inactiveColor',
          displayName: {
            en: 'Inactive Color',
            ja: '非アクティブ時の色',
          },
          type: 'color',
          default: '#bbb',
          enabled: {
            iconType: 'toggle',
          },
        },
      ],
    },
    {
      name: 'icon2',
      displayName: {
        en: 'Icon 2',
        ja: 'アイコン2',
      },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'iconType',
          displayName: {
            en: 'Type',
            ja: 'タイプ',
          },
          type: 'text',
          default: 'icon',
          control: {
            type: 'menu',
            options: [
              {
                label: 'Icon',
                value: 'icon',
              },
              {
                label: 'Toggle',
                value: 'toggle',
              },
            ],
          },
        },
        {
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          name: 'icon',
          type: 'icon',
          default: 'share',
        },
        {
          name: 'onPress',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
          type: 'action',
          enabled: {
            iconType: ['icon', 'toggle'],
          },
        },
        {
          name: 'color',
          displayName: {
            en: 'Icon Color',
            ja: 'アイコン色',
          },
          type: 'color',
          default: '@primary',
        },
        {
          name: 'input',
          displayName: {
            en: 'What does this toggle?',
            ja: 'データを選択してください',
          },
          type: 'boolean',
          role: 'autosaveInput',
          enabled: {
            iconType: 'toggle',
          },
        },
        {
          name: 'activeIcon',
          displayName: {
            en: 'Active Icon',
            ja: 'アクティブ時のアイコン',
          },
          type: 'icon',
          default: 'check-box',
          enabled: {
            iconType: 'toggle',
          },
        },
        {
          name: 'activeColor',
          displayName: {
            en: 'Active Color',
            ja: 'アクティブ時の色',
          },
          type: 'color',
          default: '@primary',
          enabled: {
            iconType: 'toggle',
          },
        },
        {
          name: 'inactiveIcon',
          displayName: {
            en: 'Inactive Icon',
            ja: '非アクティブ時のアイコン',
          },
          type: 'icon',
          default: 'check-box-outline-blank',
          enabled: {
            iconType: 'toggle',
          },
        },
        {
          name: 'inactiveColor',
          displayName: {
            en: 'Inactive Color',
            ja: '非アクティブ時の色',
          },
          type: 'color',
          default: '#bbb',
          enabled: {
            iconType: 'toggle',
          },
        },
      ],
    },
  ],
  style: {
    opacity: true,
    fontFamily: true,
    fontSize: true,
    backgroundColor: true,
    border: true,
    borderRadius: true,
    gap: true,
    shadow: true,
    iconColor: '@primary',
  },
};
